import {
  type AvatarVariant,
  Avatar as MantineAvatar,
  type MantineRadius,
} from "@mantine/core";
import { forwardRef } from "react";

export interface AvatarProps {
  user: {
    avatar?: string | null;
    name: string;
    id?: number;
    userId?: number;
  };
  size?: string;
  variant?: AvatarVariant;
  radius?: MantineRadius;
}

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>((
  { user, size, variant, radius }: AvatarProps,
  ref,
) => {
  const {
    avatar,
    name,
    id,
    userId,
  } = user;

  let src: string | null = null;
  if (avatar && id) {
    src = `/api/users/${userId ?? id}/avatars/${avatar}`;
  }

  return <MantineAvatar {...{ src, size, ref, name, variant, radius }} />;
});
